import {$window, $body} from '../../../../../ig_template/Resources/Public/JavaScript/Constants';

/**
 * FbFeedSlider
 */
export default class FbFeedSlider {
    constructor($fbFeedSlider) {
        this.$fbFeedSlider = $fbFeedSlider;
        this.initSlider();
    }

    initSlider() {
        this.$fbFeedSlider.addClass('owl-carousel');
        this.$fbFeedSlider.owlCarousel({
            items: 1,
            autoplay: true,
            autoplayHoverPause: true,
            loop: true,
            margin: 30,
            autoWidth: false,
            nav: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            onInitialized: () => {
                this.$fbFeedSlider.find('.fbPost .row').each(function() {
                    $(this).on('postequalized.zf.equalizer', function() {
                        $(this).addClass('equalized');
                    });
                });

                if($window.width() >= 640) {
                    if($window.width() < 768) {
                        new Foundation.Equalizer(this.$fbFeedSlider).applyHeight();

                        this.$fbFeedSlider.find('.fbPost .row').each(function() {
                            new Foundation.Equalizer($(this)).applyHeight();
                        });
                    }else {
                        if($window.width() >= 1200) {
                            new Foundation.Equalizer(this.$fbFeedSlider).applyHeight();

                            this.$fbFeedSlider.find('.fbPost .row').each(function() {
                                new Foundation.Equalizer($(this)).applyHeight();
                            });
                        }
                    }
                }
            },
            responsive: {
                768: {
                    items: 2
                },
                1700: {
                    stagePadding: 80,
                    items: 2
                }
            }
        });
    }
}